module.exports = __webpack_public_path__ + "media/images/content/image-73d0b5e4a29c6751e1c0badbe7941c74.svg";